import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import NumberCard from "@/components/custom/NumberCard";
import CardWarnIcon from "@/assets/icons/CarWarnIcon.svg";
import WifiOffIcon from "@/assets/icons/WifiOffIcon.svg";
import ButtonCard from "@/components/custom/ButtonCard";
import ChargerPlugIcon from "@/assets/icons/ChargerPlugIcon.svg";
import { useTheme } from "@/themeConfigs/ThemeContext";
import DashboardService from "@/services/api/DashboardService";
import { ChargerStatusDashboardResponse } from "@/central-atoms/everest-fleet-pwa/responses";
import { setChargerStatus } from "@/redux/chargerStatusSlice";

interface ChargerStatusTabProps {
  hubName: string;
}

const ChargerStatusTab: React.FC<ChargerStatusTabProps> = ({ hubName }) => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const [chargerStatusDashboard, setChargerStatusDashboard] =
    useState<ChargerStatusDashboardResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchChargerStatusDashboard = async () => {
      try {
        const data = await DashboardService.getChargerStatusDashboard(hubName);
        setChargerStatusDashboard(data);
        dispatch(setChargerStatus(data.data.data.charger_status));
      } catch (error) {
        console.error("Failed to fetch charger status dashboard", error);
        setError("Failed to load charger status data.");
      }
    };

    fetchChargerStatusDashboard();
  }, [hubName, dispatch]);

  if (!chargerStatusDashboard) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="grid grid-cols-2 mt-4 gap-x-2">
        <NumberCard
          number={chargerStatusDashboard.data.data.charger_status.offline}
          text="Offline"
          icon={CardWarnIcon}
        />
        <NumberCard
          number={chargerStatusDashboard.data.data.charger_status.faulty}
          text="Faulted"
          icon={WifiOffIcon}
        />
      </div>
      <div className="pt-4 flex flex-col gap-y-4">
        <ButtonCard
          icon={ChargerPlugIcon}
          color={theme.colors.secondary}
          text="In Charging"
          number={chargerStatusDashboard.data.data.charger_status.cars_charging}
          navigateTo="/in-charging"
        />
        <ButtonCard
          icon={ChargerPlugIcon}
          color={theme.colors["supervisor-red"]}
          text="Chargers with vehicle @100%"
          number={
            chargerStatusDashboard.data.data.charger_status.full_charged_cars
          }
          navigateTo="/fully-charged"
        />
      </div>
      {error && <p className="text-red-500 text-center">{error}</p>}
    </>
  );
};

export default ChargerStatusTab;
